import "./DeleteDialog.css";
import { FunctionComponent, useEffect, useState } from "react";
import { DeleteDialogProps } from "./IDeleteDialog";
import Dialog from "../Dialog/Dialog";
import { Button } from "@mui/material";

const DeleteDialog: FunctionComponent<DeleteDialogProps> = (props) => {
  const { open, setOpen, deleteFunction, deleteableName } = props;
  const [responseDialog, setResponseDialog] = useState<boolean>(false);
  const handleClose = () => {
    setOpen(false);
    setResponseDialog(false);
  };

  return (
    <Dialog
      open={open}
      Dialog_Title={
        <div className="delete_dialog_header">
          Delete
        </div>
      }
      Dialog_Content={
        <>
          Are you sure you want to delete <b>{deleteableName}</b>?
        </>
      }
      Dialog_Actions={
        <div className="delete_dialog_footer">
          <Button
            disableRipple
            className="common_btn_outline"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <Button disableRipple className="common_btn" onClick={deleteFunction}>
            Delete
          </Button>
        </div>
      }
    />
  );
};

export default DeleteDialog;
